import React from 'react';
import AvatarContainer from '../Avatars/AvatarContainer';
import { ListItemContainer, Pill } from './GestionComponents';
import { Pencil } from 'react-ionicons';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

const GestionItem = ({ station, showPen = true, max = null, width }) => {
  let history = useHistory();
  const { provinceIdMap } = useSelector((state) => state.stations);

  let { IsActive } = station;

  const returnActiveText = (isStationActive) =>
    isStationActive ? 'activo' : 'inactivo';

  const goToEdit = (id) => {
    history.push(`/editar/${id}`);
  };

  return (
    <ListItemContainer
      style={{
        height: width ? '85px' : '65px',
        maxWidth: width ? '460px' : '',
        marginBottom: '15px',
      }}>
      <AvatarContainer width={width} station={station} />
      <div className="box-item">
        <h3 style={{ margin: 0 }}>{station.Name}</h3>
        <h6 style={{ margin: 0, paddingLeft: '2px', fontWeight: '500' }}>
          {provinceIdMap[station.PlaceId]?.Name ?? 'N/A'}
        </h6>
      </div>
      <div
        style={{
          marginLeft: 'auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <Pill state={returnActiveText(IsActive)}>
          {returnActiveText(IsActive)}
        </Pill>
        {showPen ? (
          <Pencil
            onClick={() => goToEdit(station.Id)}
            style={{ paddingLeft: '5px', cursor: 'pointer' }}
            color={'#003876'}
            height="30px"
            width="30px"
          />
        ) : null}
      </div>
    </ListItemContainer>
  );
};

export default GestionItem;
